import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from 'react-router-dom';
import { Badge } from 'react-bootstrap';  // Import Bootstrap Badge
import 'bootstrap/dist/css/bootstrap.min.css';
import './empStyle.css';
import config from '../../config.json';
import EmpLabel from './EmpLabel';

const apiUrl = config.apiUrl;
const getStatusBadge = (status) => {
    let variant;
    switch (status) {
        case 'Rejected':
            variant = 'danger';
            break;
        case 'Pending':
            variant = 'primary';
            break;
        case 'Approved':
            variant = 'success';
            break;
        default:
            variant = 'secondary';
    }
    return <Badge bg={variant}>{status}</Badge>;
};


const EmpDetails = () => {
    const [employeeDetails, setEmployeeDetails] = useState({
        IDNumber: '',
        LastName: '',
        FirstName: '',
        MiddleInitial: '',
        Position: '',
        User: [],
        Status: '',
        CreatedBy: '',
        CreatedDate: '',
        UpdatedBy: '',
        UpdatedDate: '',
    });

    const { employeeId } = useParams();

    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');

    const navigate = useNavigate();

    // Overtime
    const [overtimeCurrentPage, setOvertimeCurrentPage] = useState(1);
    const [overtimeTotalPages, setOvertimeTotalPages] = useState(0);
    const [overtimeItemsPerPage, setOvertimeItemsPerPage] = useState(5);

    // Leave
    const [leaveCurrentPage, setLeaveCurrentPage] = useState(1);
    const [leaveTotalPages, setLeaveTotalPages] = useState(0);
    const [leaveItemsPerPage, setLeaveItemsPerPage] = useState(5);

    // Undertime
    const [undertimeCurrentPage, setUndertimeCurrentPage] = useState(1);
    const [undertimeTotalPages, setUndertimeTotalPages] = useState(0);
    const [undertimeItemsPerPage, setUndertimeItemsPerPage] = useState(5);

    // TimeEntry
    const [timeEntryCurrentPage, setTimeEntryCurrentPage] = useState(1);
    const [timeEntryTotalPages, setTimeEntryTotalPages] = useState(0);
    const [timeEntryItemsPerPage, setTimeEntryItemsPerPage] = useState(5);


    const [overtimeData, setOvertimeData] = useState([]);
    const [leaveData, setLeaveData] = useState([]);
    const [undertimeData, setUndertimeData] = useState([]);
    const [timeentryData, setTimeEntryData] = useState([]);
    const roles = JSON.parse(localStorage.getItem('Roles'));

    const userAccess = {
        hasView: roles?.includes('View') || false,
        hasAdmin: roles?.includes('Admin') || false,
        hasApprover: roles?.includes('Approver') || false,
        hasStandard: roles?.includes('Standard') || false,
    };

    const { hasView, hasAdmin, hasStandard, hasApprover } = userAccess;

    const [activeTab, setActiveTab] = useState('Overtime');

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    useEffect(() => {
        if (employeeId) {
            fetchEmployeeData(employeeId);
            fetchOvertimeData(employeeId);
            fetchLeaveData(employeeId);
            fetchUndertimeData(employeeId);
            fetchTimeEntryData(employeeId);
        }
    }, []);

    const fetchOvertimeData = async (employeeId) => {
        const token = localStorage.getItem('token');
        const statuses = [0, 1, 2];
        const statusQueryString = statuses.map((status) => `statuses=${status}`).join('&');
        try {
            const response = await fetch(`${apiUrl}/Overtime?${statusQueryString}&empID=${employeeId}&pageNumber=${overtimeCurrentPage}&pageSize=${overtimeItemsPerPage}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                if (response.status === 401) {
                    // Redirect to login page if unauthorized
                    window.location.href = `${config.identityUrl}/Identity/Account/Login`;
                } else {
                    // Handle other error cases
                    setErrorMessage('Failed to fetch overtime data');
                    setSuccessMessage('');
                    return;
                }
            }

            const result = await response.json();
            setOvertimeData(result.Data || []);
            setOvertimeTotalPages(result.TotalPages || 0);

        } catch (error) {
            setErrorMessage('Error fetching overtime data');
            setSuccessMessage('');
        }
    };

    const fetchLeaveData = async (employeeId) => {
        const token = localStorage.getItem('token');
        const statuses = [0, 1, 2];
        const statusQueryString = statuses.map((status) => `statuses=${status}`).join('&');
        try {
            const response = await fetch(`${apiUrl}/Leave?${statusQueryString}&empID=${employeeId}&pageNumber=${leaveCurrentPage}&pageSize=${leaveItemsPerPage}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                if (response.status === 401) {
                    // Redirect to login page if unauthorized
                    window.location.href = `${config.identityUrl}/Identity/Account/Login`;
                } else {
                    // Handle other error cases

                    return;
                }
            }

            const result = await response.json();
            setLeaveData(result.Data || []);
            setLeaveTotalPages(result.TotalPages || 0);

        } catch (error) {
            setErrorMessage('Error fetching leave data');
            setSuccessMessage('');
        }
    };

    const fetchUndertimeData = async (employeeId) => {
        const token = localStorage.getItem('token');
        const statuses = [0, 1, 2];
        const statusQueryString = statuses.map((status) => `statuses=${status}`).join('&');
        try {
            const response = await fetch(`${apiUrl}/Undertime?${statusQueryString}&empID=${employeeId}&pageNumber=${undertimeCurrentPage}&pageSize=${undertimeItemsPerPage}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                if (response.status === 401) {
                    // Redirect to login page if unauthorized
                    window.location.href = `${config.identityUrl}/Identity/Account/Login`;
                } else {
                    setErrorMessage('Error fetching undertime data');
                    setSuccessMessage('');
                    return;
                }

            }

            const result = await response.json();
            setUndertimeData(result.Data || []);
            setUndertimeTotalPages(result.TotalPages || 0);

        } catch (error) {
            setErrorMessage('Error fetching undertime data');
            setSuccessMessage('');
        }
    };

    const fetchTimeEntryData = async (employeeId) => {
        const token = localStorage.getItem('token');
        const statuses = [0, 1, 2];
        const statusQueryString = statuses.map((status) => `statuses=${status}`).join('&');
        try {
            const response = await fetch(`${apiUrl}/TimeEntry?${statusQueryString}&employeeID=${employeeId}&pageNumber=${timeEntryCurrentPage}&pageSize=${timeEntryItemsPerPage}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            if (!response.ok) {
                if (response.status === 401) {
                    // Redirect to login page if unauthorized
                    window.location.href = `${config.identityUrl}/Identity/Account/Login`;
                } else {
                    setErrorMessage('Error fetching time entrys data');
                    setSuccessMessage('');
                    return;
                }

            }

            const result = await response.json();
            setTimeEntryData(result.Data || []);
            setTimeEntryTotalPages(result.TotalPages || 0);

        } catch (error) {
            setErrorMessage('Error fetching time entry data');
            setSuccessMessage('');
        }
    };

    const fetchEmployeeData = async (employeeId) => {
        const token = localStorage.getItem('token');
        try {
            const response = await fetch(`${apiUrl}/Employee/${employeeId}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });

            const data = await response.json();
            if (!response.ok) {
                if (response.status === 401) {
                    // Redirect to login page if unauthorized
                    window.location.href = `${config.identityUrl}/Identity/Account/Login`;
                } else {
                    setErrorMessage('Failed to fetch employee data');
                    setSuccessMessage('');
                    return;
                }
            }

            setEmployeeDetails({
                IDNumber: data.Details.IdNumber,
                LastName: data.Details.LastName,
                FirstName: data.Details.FirstName,
                MiddleInitial: data.Details.MiddleInitial,
                Position: data.Details.Position,
                User: data.Details.User || [],
                Status: data.Details.Status,
                CreatedBy: data.Details.CreatedBy,
                CreatedDate: data.Details.CreatedDate,
                UpdatedBy: data.Details.UpdatedBy,
                UpdatedDate: data.Details.UpdatedDate,
            });

        } catch (error) {
            setErrorMessage('Error fetching employee data');
            setSuccessMessage('');
        }
    };

    useEffect(() => {
        fetchOvertimeData(employeeId);
    }, [overtimeCurrentPage, overtimeItemsPerPage]);

    useEffect(() => {
        fetchLeaveData(employeeId);
    }, [leaveCurrentPage, leaveItemsPerPage]);

    useEffect(() => {
        fetchUndertimeData(employeeId);
    }, [undertimeCurrentPage, undertimeItemsPerPage]);

    useEffect(() => {
        fetchTimeEntryData(employeeId);
    }, [timeEntryCurrentPage, timeEntryItemsPerPage]);

    const { IDNumber, LastName, FirstName, MiddleInitial, Position, User, Status, CreatedBy, CreatedDate, UpdatedBy, UpdatedDate } = employeeDetails;

    return (
        <div>
            {(userAccess.hasAdmin || userAccess.hasStandard) ? (
                <>
                    <h3>View Employee</h3>
                    {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
                    {successMessage && <div className="alert alert-success">{successMessage}</div>}
                    <div className="row mt-4">
                        <div className="col-md-6">
                            <EmpLabel label="ID Number" value={IDNumber} />
                            <EmpLabel label="First Name" value={FirstName} />
                            <EmpLabel label="Middle Name" value={MiddleInitial} />
                            <EmpLabel label="Last Name" value={LastName} />
                            <EmpLabel label="Position" value={Position} />
                            <EmpLabel label="User" value={User.Email} />

                            <div className="mb-2">
                                <Link to="/employee-list" className="btn btn-secondary">Back</Link>
                                {userAccess.hasAdmin && (
                                    <Link to={`/employee-update/${employeeId}`}
                                        className={`btn btn-primary ms-2 ${Status === 'Inactive' ? 'disabled' : ''}`}>Edit
                                    </Link>
                                )}
                            </div>

                        </div>
                        <div className="col-md-6">
                            <EmpLabel label="Status" value={Status} />
                            <EmpLabel label="Created By" value={CreatedBy} />
                            <EmpLabel label="Created Date" value={CreatedDate} />
                            <EmpLabel label="Updated By" value={UpdatedBy} />
                            <EmpLabel label="Updated Date" value={UpdatedDate} />
                        </div>
                    </div>

                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <div
                                className={`nav-link ${activeTab === 'Overtime' ? 'active' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleTabClick('Overtime')}
                            >
                                Overtime
                            </div>
                        </li>
                        <li className="nav-item">
                            <div
                                className={`nav-link ${activeTab === 'Leave' ? 'active' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleTabClick('Leave')}
                            >
                                Leave
                            </div>
                        </li>
                        <li className="nav-item">
                            <div
                                className={`nav-link ${activeTab === 'Undertime' ? 'active' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleTabClick('Undertime')}
                            >
                                Undertime
                            </div>
                        </li>
                        <li className="nav-item">
                            <div
                                className={`nav-link ${activeTab === 'TimeEntry' ? 'active' : ''}`}
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleTabClick('TimeEntry')}
                            >
                                Time Entries
                            </div>
                        </li>
                    </ul>

                    <div className="tab-content mt-3">
                        <div
                            className={`tab-pane ${activeTab === 'Overtime' ? 'active show' : ''}`}
                        >
                            <table className='custom-table'>
                                <thead>
                                    <tr>
                                        <th className='border-end-0'>Transaction ID</th>
                                        <th className='border-start-0 border-end-0'>Transaction Date</th>
                                        <th className='border-start-0 border-end-0'>Employee</th>
                                        <th className='border-start-0 border-end-0'>Date Start</th>
                                        <th className='border-start-0 border-end-0'>Date End</th>
                                        <th className='border-start-0 border-end-0'>Duration</th>
                                        <th className='border-start-0'>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {overtimeData && overtimeData.length > 0 ? (
                                        overtimeData.map((item) => (
                                            <React.Fragment key={item.ID}>
                                                <tr>
                                                    <td className='border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionID}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionDate}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Employee.Name}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.DateStart}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.DateEnd}</td>
                                                    <td className='text-end border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Duration}</td>
                                                    <td className='border-start-0' style={{ borderBottom: 'none' }}>{getStatusBadge(item.Status)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="9" style={{ borderTop: 'none', maxWidth: '50px' }}>
                                                        <strong>Remarks:</strong> {item.Remarks}
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9">No Data</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul className="pagination mt-3">
                                    <li className={`page-item ${overtimeCurrentPage === 1 ? 'disabled' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setOvertimeCurrentPage(1)}
                                            aria-label="First"
                                        >
                                            <span aria-hidden="true">&laquo;&laquo;</span>
                                        </button>
                                    </li>
                                    <li className={`page-item ${overtimeCurrentPage === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => setOvertimeCurrentPage(overtimeCurrentPage - 1)} aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                        </button>
                                    </li>
                                    {(() => {
                                        const pageGroupSize = 5; // Only 5 pages visible at once
                                        const currentGroup = Math.floor((overtimeCurrentPage - 1) / pageGroupSize);
                                        const startPage = currentGroup * pageGroupSize + 1;
                                        const endPage = Math.min(startPage + pageGroupSize - 1, overtimeTotalPages);

                                        const visiblePages = Array.from(
                                            { length: endPage - startPage + 1 },
                                            (_, index) => startPage + index
                                        );

                                        return visiblePages.map((page) => (
                                            <li key={page} className={`page-item ${overtimeCurrentPage === page ? 'active' : ''}`}>
                                                <button className="page-link" onClick={() => setOvertimeCurrentPage(page)}>
                                                    {page}
                                                </button>
                                            </li>
                                        ));
                                    })()}
                                    <li className={`page-item ${overtimeCurrentPage === overtimeTotalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => setOvertimeCurrentPage(overtimeCurrentPage + 1)} aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                        </button>
                                    </li>
                                    <li className={`page-item ${overtimeCurrentPage === overtimeTotalPages ? 'disabled' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setOvertimeCurrentPage(overtimeTotalPages)}
                                            aria-label="Last"
                                        >
                                            <span aria-hidden="true">&raquo;&raquo;</span>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div
                            className={`tab-pane ${activeTab === 'Leave' ? 'active show' : ''}`}
                        >
                            <table className='custom-table'>
                                <thead>
                                    <tr>
                                        <th className='border-end-0'>Transaction ID</th>
                                        <th className='border-start-0 border-end-0'>Transaction Date</th>
                                        <th className='border-start-0 border-end-0'>Employee</th>
                                        <th className='border-start-0 border-end-0'>Leave Type</th>
                                        <th className='border-start-0 border-end-0'>Date Start</th>
                                        <th className='border-start-0 border-end-0'>Date End</th>
                                        <th className='border-start-0 border-end-0'>Duration</th>
                                        <th className='border-start-0'>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {leaveData && leaveData.length > 0 ? (
                                        leaveData.map((item) => (
                                            <React.Fragment key={item.ID}>
                                                <tr>
                                                    <td className='border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionID}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionDate}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Employee.Name}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.LeaveType}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.DateStart}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.DateEnd}</td>
                                                    <td className='text-end border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Duration}</td>
                                                    <td className='border-start-0' style={{ borderBottom: 'none' }}>{getStatusBadge(item.Status)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="10" style={{ borderTop: 'none', maxWidth: '50px' }}>
                                                        <strong>Remarks:</strong> {item.Remarks}
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="10">No Data</td>
                                        </tr>
                                    )

                                    }
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul className="pagination mt-3">
                                    <li className={`page-item ${leaveCurrentPage === 1 ? 'disabled' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setLeaveCurrentPage(1)}
                                            aria-label="First"
                                        >
                                            <span aria-hidden="true">&laquo;&laquo;</span>
                                        </button>
                                    </li>
                                    <li className={`page-item ${leaveCurrentPage === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => setLeaveCurrentPage(leaveCurrentPage - 1)} aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                        </button>
                                    </li>
                                    {(() => {
                                        const pageGroupSize = 5; // Only 5 pages visible at once
                                        const currentGroup = Math.floor((leaveCurrentPage - 1) / pageGroupSize);
                                        const startPage = currentGroup * pageGroupSize + 1;
                                        const endPage = Math.min(startPage + pageGroupSize - 1, leaveTotalPages);

                                        const visiblePages = Array.from(
                                            { length: endPage - startPage + 1 },
                                            (_, index) => startPage + index
                                        );

                                        return visiblePages.map((page) => (
                                            <li key={page} className={`page-item ${leaveCurrentPage === page ? 'active' : ''}`}>
                                                <button className="page-link" onClick={() => setLeaveCurrentPage(page)}>
                                                    {page}
                                                </button>
                                            </li>
                                        ));
                                    })()}
                                    <li className={`page-item ${leaveCurrentPage === leaveTotalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => setLeaveCurrentPage(leaveCurrentPage + 1)} aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                        </button>
                                    </li>
                                    <li className={`page-item ${leaveCurrentPage === leaveTotalPages ? 'disabled' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setLeaveCurrentPage(leaveTotalPages)}
                                            aria-label="Last"
                                        >
                                            <span aria-hidden="true">&raquo;&raquo;</span>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div
                            className={`tab-pane ${activeTab === 'Undertime' ? 'active show' : ''}`}
                        >
                            <table className='custom-table'>
                                <thead>
                                    <tr>
                                        <th className='border-end-0'>Transaction ID</th>
                                        <th className='border-start-0 border-end-0'>Transaction Date</th>
                                        <th className='border-start-0 border-end-0'>Employee</th>
                                        <th className='border-start-0 border-end-0'>Date Start</th>
                                        <th className='border-start-0 border-end-0'>Date End</th>
                                        <th className='border-start-0 border-end-0'>Duration</th>
                                        <th className='border-start-0'>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {undertimeData && undertimeData.length > 0 ? (
                                        undertimeData.map((item) => (
                                            <React.Fragment key={item.ID}>
                                                <tr>
                                                    <td className='border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionID}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionDate}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Employee.Name}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.DateStart}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.DateEnd}</td>
                                                    <td className='text-end border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Duration}</td>
                                                    <td className='border-start-0' style={{ borderBottom: 'none' }}>{getStatusBadge(item.Status)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="9" style={{ borderTop: 'none', maxWidth: '50px' }}>
                                                        <strong>Remarks:</strong> {item.Remarks}
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9">No Data</td>
                                        </tr>
                                    )

                                    }
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul className="pagination mt-3">
                                    <li className={`page-item ${undertimeCurrentPage === 1 ? 'disabled' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setUndertimeCurrentPage(1)}
                                            aria-label="First"
                                        >
                                            <span aria-hidden="true">&laquo;&laquo;</span>
                                        </button>
                                    </li>
                                    <li className={`page-item ${undertimeCurrentPage === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => setUndertimeCurrentPage(undertimeCurrentPage - 1)} aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                        </button>
                                    </li>
                                    {(() => {
                                        const pageGroupSize = 5; // Only 5 pages visible at once
                                        const currentGroup = Math.floor((undertimeCurrentPage - 1) / pageGroupSize);
                                        const startPage = currentGroup * pageGroupSize + 1;
                                        const endPage = Math.min(startPage + pageGroupSize - 1, undertimeTotalPages);

                                        const visiblePages = Array.from(
                                            { length: endPage - startPage + 1 },
                                            (_, index) => startPage + index
                                        );

                                        return visiblePages.map((page) => (
                                            <li key={page} className={`page-item ${undertimeCurrentPage === page ? 'active' : ''}`}>
                                                <button className="page-link" onClick={() => setUndertimeCurrentPage(page)}>
                                                    {page}
                                                </button>
                                            </li>
                                        ));
                                    })()}
                                    <li className={`page-item ${undertimeCurrentPage === undertimeTotalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => setUndertimeCurrentPage(undertimeCurrentPage + 1)} aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                        </button>
                                    </li>
                                    <li className={`page-item ${undertimeCurrentPage === undertimeTotalPages ? 'disabled' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setUndertimeCurrentPage(undertimeTotalPages)}
                                            aria-label="Last"
                                        >
                                            <span aria-hidden="true">&raquo;&raquo;</span>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                        <div
                            className={`tab-pane ${activeTab === 'TimeEntry' ? 'active show' : ''}`}
                        >
                            <table className='custom-table'>
                                <thead>
                                    <tr>
                                        <th className='border-end-0'>Transaction Date</th>
                                        <th className='border-start-0 border-end-0'>Employee</th>
                                        <th className='border-start-0 border-end-0'>Start Date</th>
                                        <th className='border-start-0 border-end-0'>End Date</th>
                                        <th className='border-start-0 border-end-0'>Duration</th>
                                        <th className='border-start-0 border-end-0'>Entry Type</th>
                                        <th className='border-start-0'>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {timeentryData && timeentryData.length > 0 ? (
                                        timeentryData.map((item) => (
                                            <React.Fragment key={item.ID}>
                                                <tr>
                                                    <td className='border-end-0' style={{ borderBottom: 'none' }}>{item.TransactionDate}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Employee.Name}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.StartDate}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.EndDate}</td>
                                                    <td className='text-end border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.Duration}</td>
                                                    <td className='border-start-0 border-end-0' style={{ borderBottom: 'none' }}>{item.EntryTypeID}</td>
                                                    <td className='border-start-0' style={{ borderBottom: 'none' }}>{getStatusBadge(item.Status)}</td>
                                                </tr>
                                                <tr>
                                                    <td colSpan="9" style={{ borderTop: 'none', maxWidth: '50px' }}>
                                                        <strong>Remarks:</strong> {item.Remarks}
                                                    </td>
                                                </tr>
                                            </React.Fragment>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="9">No Data</td>
                                        </tr>
                                    )

                                    }
                                </tbody>
                            </table>
                            <nav aria-label="Page navigation">
                                <ul className="pagination mt-3">
                                    <li className={`page-item ${timeEntryCurrentPage === 1 ? 'disabled' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setTimeEntryCurrentPage(1)}
                                            aria-label="First"
                                        >
                                            <span aria-hidden="true">&laquo;&laquo;</span>
                                        </button>
                                    </li>
                                    <li className={`page-item ${timeEntryCurrentPage === 1 ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => setTimeEntryCurrentPage(timeEntryCurrentPage - 1)} aria-label="Previous">
                                            <span aria-hidden="true">&laquo;</span>
                                        </button>
                                    </li>
                                    {(() => {
                                        const pageGroupSize = 5; // Only 5 pages visible at once
                                        const currentGroup = Math.floor((timeEntryCurrentPage - 1) / pageGroupSize);
                                        const startPage = currentGroup * pageGroupSize + 1;
                                        const endPage = Math.min(startPage + pageGroupSize - 1, timeEntryTotalPages);

                                        const visiblePages = Array.from(
                                            { length: endPage - startPage + 1 },
                                            (_, index) => startPage + index
                                        );

                                        return visiblePages.map((page) => (
                                            <li key={page} className={`page-item ${timeEntryCurrentPage === page ? 'active' : ''}`}>
                                                <button className="page-link" onClick={() => setTimeEntryCurrentPage(page)}>
                                                    {page}
                                                </button>
                                            </li>
                                        ));
                                    })()}
                                    <li className={`page-item ${timeEntryCurrentPage === timeEntryTotalPages ? 'disabled' : ''}`}>
                                        <button className="page-link" onClick={() => setTimeEntryCurrentPage(timeEntryCurrentPage + 1)} aria-label="Next">
                                            <span aria-hidden="true">&raquo;</span>
                                        </button>
                                    </li>
                                    <li className={`page-item ${timeEntryCurrentPage === timeEntryTotalPages ? 'disabled' : ''}`}>
                                        <button
                                            className="page-link"
                                            onClick={() => setTimeEntryCurrentPage(timeEntryTotalPages)}
                                            aria-label="Last"
                                        >
                                            <span aria-hidden="true">&raquo;&raquo;</span>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </>
            ) : (
                <div>
                    <h3>No access!</h3>
                    <button className="btn btn-primary" onClick={() => navigate(-1)}>
                        Go Back
                    </button>
                </div>
            )}
        </div>
    )
}

export default EmpDetails